'use strict';

import parseBoolean from 'utils/parse-boolean';

const SELECTOR = '.js-directory';

(function () {
    const elements = document.querySelectorAll(SELECTOR);

    if (!elements.length) {
        return;
    }

    elements.forEach(element => {
        const handleToggleClass = element.dataset.handleToggleClass || 'is-toggled';
        const targetToggleClass = element.dataset.targetToggleClass || 'is-toggled';

        const handles = element.querySelectorAll('[data-directory-toggle]');

        const close = handle => {
            const toggleElement = element.querySelector(
                handle.dataset.directoryToggle
            );

            if (!toggleElement) {
                return false;
            }

            handle.classList.remove(handleToggleClass);
            toggleElement.classList.remove(targetToggleClass);

            handle.setAttribute('aria-expanded', 'false');
            toggleElement.setAttribute('aria-hidden', 'true');
        }

        const open = handle => {
            const toggleElement = element.querySelector(
                handle.dataset.directoryToggle
            );

            if (!toggleElement) {
                return false;
            }

            handle.classList.add(handleToggleClass);
            toggleElement.classList.add(targetToggleClass);

            handle.setAttribute('aria-expanded', 'true');
            toggleElement.setAttribute('aria-hidden', 'false');
        }

        const closeOthers = () => {
            handles.forEach(handle => {
                if (handle.classList.contains(handleToggleClass)) {
                    close(handle);
                }
            });
        }

        handles.forEach(handle => {
            const isOpen = parseBoolean(handle.dataset.directoryOpen, false);

            handle.addEventListener('click', () => {
                closeOthers();

                open(handle);
            }, false);

            if (isOpen) {
                handle.click();
            }
        });
    });
}());
